class MkDiscountForm extends HTMLElement {
  connectedCallback() {
    this.querySelector('.mk-discount__submit')?.addEventListener('click', (event) => { event.preventDefault(); this.apply(); });
    this.querySelector('[name="discount_code"]')?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') { event.preventDefault(); this.apply(); }
    });
    this.bindRemoveButtons();
  }

  bindRemoveButtons() {
    document.querySelectorAll('.mk-discount__remove').forEach((button) => {
      if (button.dataset.mkBound === '1') return;
      button.dataset.mkBound = '1';
      button.addEventListener('click', (event) => { event.preventDefault(); this.removeCode(); });
    });
  }

  showError(message) {
    const target = document.querySelector('mk-discount-form .mk-discount__error');
    if (target) { target.textContent = message; target.hidden = !message; }
  }

  async refresh() {
    await window.MKCartSync.refresh();
    this.bindRemoveButtons();
  }

  codeApplications() {
    const host = document.querySelector('mk-discount-form');
    return Number(host?.dataset.codeDiscounts || 0);
  }

  async apply() {
    const code = (this.querySelector('[name="discount_code"]')?.value || '').trim();
    if (!code || window.MKCartSync.busy) return;
    this.showError('');
    try {
      const cart = await window.MKCartSync.run(() => window.MKCartSync.post(routes.cart_update_url, { discount: code }));
      const codes = cart.discount_codes || [];
      const match = codes.find((entry) => entry.code?.toUpperCase() === code.toUpperCase());
      const applied = match ? match.applicable : this.codeApplications() > 0;
      if (!applied) this.showError('Ce code est invalide ou non applicable à votre panier.');
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mk-cart-sync', cartData: cart });
    } catch (error) {
      console.error('[mk-discount]', error);
      this.showError('Une erreur est survenue. Réessayez.');
    }
  }

  async removeCode() {
    if (window.MKCartSync.busy) return;
    if (!this.codeApplications()) {
      this.showError('Cette réduction est automatique : elle ne peut pas être retirée depuis le panier.');
      return;
    }
    this.showError('');
    try {
      const cart = await window.MKCartSync.run(() => window.MKCartSync.post(routes.cart_update_url, { discount: '' }));
      if (this.codeApplications() > 0) this.showError('Impossible de retirer le code. Réessayez.');
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mk-cart-sync', cartData: cart });
    } catch (error) {
      console.error('[mk-discount]', error);
      this.showError('Impossible de retirer le code. Réessayez.');
    }
  }
}
if (!customElements.get('mk-discount-form')) customElements.define('mk-discount-form', MkDiscountForm);
